module.exports = __webpack_public_path__ + "static/media/womenintech.fec8c9cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/womenintech.jpg
// module id = 402
// module chunks = 0